export default {
    SET_NEW_PASSWORD_LOADING: 'SET_NEW_PASSWORD_LOADING',
    SET_NEW_PASSWORD_SUCCESS: 'SET_NEW_PASSWORD_SUCCESS',
    SET_NEW_PASSWORD_FAILED: 'SET_NEW_PASSWORD_FAILED',
    SET_NEW_PASSWORD_REJECT: 'SET_NEW_PASSWORD_REJECT',
  };